import ApplicationAdapter from '../application';

export default class Audit extends ApplicationAdapter {
  namespace = 'people/v4';
  modelNamePlural = 'audits';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('people/', '')
      .toLowerCase();
  }
}
